module.exports = "<p-growl [value]=\"msgs\" ></p-growl>\r\n<app-loading *ngIf=\"loading\"></app-loading>\r\n<p-menubar [model]=\"items\"></p-menubar>\r\n\r\n<router-outlet></router-outlet>\r\n\r\n\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// H:/Proyectos Galeras Indie/Vinta/vinta Tinka/VintaWebClient/src/app/navbar/navbar.component.html
// module id = ../../../../../src/app/navbar/navbar.component.html
// module chunks = 0